import { observer } from 'mobx-react';
import { KB_URL } from '../../utils/constants';
import NewWorkflowButton from './NewButton';

const NoWorkflows = observer((props) => {
    return (
        <div className="text-center flex-column mb-5">
            <h3>No Workflows created</h3>
            <p>Create a new workflow to integrate your API data into your critical business processes.</p>
            <p>
                <a href={`${KB_URL}/articles/xmey3nmV/your-first-workflow`} target="_blank" rel="noreferrer">Check our docs</a> for an intro into creating your first workflow.</p>
            <NewWorkflowButton {...props} handleShowBuilder={props.handleShowBuilder} />
        </div>  
    );
  });
  
  export default NoWorkflows;